import UnsubscribeComponent from '../components/UnsubscribeComponent/UnsubscribeComponent';

const UnsubscribePage = ({ state }) => {
    return (
        <>
            <UnsubscribeComponent state={state}/>
        </>
    );
};

export default UnsubscribePage;